var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: { size: "modal-small", "close-strict": true },
          on: {
            close: function($event) {
              _vm.$emit("close")
            }
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-10" }, [
                _vm.settlementAmount.type.name === "Office"
                  ? _c("h4", [_vm._v("Deny request for office price")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.settlementAmount.type.name === "Subco"
                  ? _c("h4", [_vm._v("Deny request for subco price")])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("div", { staticClass: "select-wrap h-auto" }, [
                    _c("label", [_vm._v("Reason for denying price")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.settlementAmount.note,
                          expression: "settlementAmount.note"
                        }
                      ],
                      staticClass: "select-wrap-textarea form-control",
                      attrs: {
                        cols: "30",
                        rows: "5",
                        placeholder: "Enter reason for denying price"
                      },
                      domProps: { value: _vm.settlementAmount.note },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.settlementAmount,
                            "note",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "note" }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c("div", { staticClass: "row mb-2 mt-4" }, [
              _c("div", { staticClass: "col text-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.$emit("close")
                      }
                    }
                  },
                  [_vm._v("\n            Cancel\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger ld-text-right",
                    class: _vm.loadingButton ? "running" : "",
                    attrs: { disabled: _vm.buttonDisabled, type: "button" },
                    on: {
                      click: function($event) {
                        _vm.updateStatus(4)
                      }
                    }
                  },
                  [
                    _vm._v("\n            Deny price request\n            "),
                    _vm.loadingButton
                      ? _c("div", { staticClass: "ld ld-ball ld-flip" })
                      : _vm._e()
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4ba8674", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ba8674","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/Modals/DeclineSettlementAmount.vue
// module id = null
// module chunks = 